<template>
  <v-app>
    <v-content> <Table /> </v-content>
  </v-app>
</template>

<script>
import Table from '@/components/DataTable/Table';
// import SVGMap from 'vue-world-map';

export default {
  name: 'DataTable',
  components: {
    Table
  }
};
</script>

<style scoped></style>
